<template>
  <div v-if="!opentoworkTooltipSeen" class="gc-shared-opentowork-box__wrapper">
    <div class="gc-shared-opentowork-box__header">Are you Open to Work ?</div>

    <div class="gc-shared-opentowork-box__body">
      Show recruiters and the Community that you’re interested in employment and
      freelance opportunities. Make sure your specialization and skills are up
      to date on your profile.

      <button @click="markAsSeen()" class="gc-shared-opentowork-box__button">
        OK, Got it!
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "gcOpentoworkTooltip",
  computed: {
    opentoworkTooltipSeen() {
      return Grabcad.opentoworkStore.state.opentoworkTooltipSeen;
    },
  },
  methods: {
    markAsSeen() {
      Grabcad.opentoworkStore.dispatch("markOpentoworkTooltipAsSeen");
    },
  },
};
</script>
